import React from "react";
import "./Skeleton.css";

export const SkeletonElement = ({ type, className = "", style = {} }) => {
  return (
    <div
      className={`skeleton-loader ${type} ${className}`}
      style={style}
    />
  );
};

export const BannerSkeleton = () => {
  return (
    <div className="w-100 mb-5">
      <SkeletonElement type="skeleton-banner" />
    </div>
  );
};

export const CardSkeleton = ({ count = 3 }) => {
  return (
    <div className="row g-4 justify-content-center w-100 m-0">
      {Array.from({ length: count }).map((_, idx) => (
        <div key={idx} className="col-lg-4 col-md-6">
          <div className="skeleton-card">
            <SkeletonElement type="skeleton-card-img" />
            <div className="skeleton-card-body">
              <SkeletonElement type="skeleton-title" />
              <SkeletonElement type="skeleton-text" />
              <SkeletonElement type="skeleton-text" className="medium" />
              <SkeletonElement type="skeleton-card-btn" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export const FacultySkeleton = ({ count = 4 }) => {
  return (
    <div className="container">
      <div className="skeleton-faculty-grid">
        {Array.from({ length: count }).map((_, idx) => (
          <div key={idx} className="skeleton-faculty-card">
            <SkeletonElement type="skeleton-faculty-avatar" />
            <SkeletonElement type="skeleton-title" className="center" style={{ width: "70%" }} />
            <SkeletonElement type="skeleton-text" className="short" style={{ margin: "0 auto 8px auto" }} />
          </div>
        ))}
      </div>
    </div>
  );
};

export const TableSkeleton = ({ rows = 5, cols = 2 }) => {
  return (
    <div className="skeleton-table-wrapper">
      <div className="skeleton-table-header" />
      {Array.from({ length: rows }).map((_, rIdx) => (
        <div key={rIdx} className="skeleton-table-row">
          {Array.from({ length: cols }).map((_, cIdx) => (
            <div
              key={cIdx}
              className="skeleton-table-cell"
              style={{
                flex: cIdx === 0 ? "3" : "1",
                width: cIdx === 0 ? "70%" : "20%"
              }}
            >
              <SkeletonElement type="skeleton-text" className={cIdx === 1 ? "short" : "medium"} />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export const AccordionSkeleton = ({ count = 3 }) => {
  return (
    <div className="w-100">
      {Array.from({ length: count }).map((_, idx) => (
        <div key={idx} className="skeleton-accordion-item">
          <div className="skeleton-accordion-header">
            <SkeletonElement type="skeleton-title" style={{ width: "40%", margin: 0 }} />
            <SkeletonElement type="skeleton-text" style={{ width: "30px", height: "30px", margin: 0, borderRadius: "50%" }} />
          </div>
          {idx === 0 && (
            <div className="skeleton-accordion-body">
              <SkeletonElement type="skeleton-text" />
              <SkeletonElement type="skeleton-text" className="medium" />
              <div className="d-flex gap-3 mt-3">
                <SkeletonElement type="skeleton-rect" style={{ width: "120px", height: "120px", borderRadius: "8px" }} />
                <SkeletonElement type="skeleton-rect" style={{ width: "120px", height: "120px", borderRadius: "8px" }} />
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export const HomeSkeleton = () => {
  return (
    <div className="w-100">
      <SkeletonElement type="skeleton-banner" style={{ height: "550px" }} />
      <div className="container py-5">
        <div className="row my-5">
          <div className="col-md-6">
            <SkeletonElement type="skeleton-title" style={{ width: "80%" }} />
            <SkeletonElement type="skeleton-text" />
            <SkeletonElement type="skeleton-text" />
            <SkeletonElement type="skeleton-text" className="medium" />
          </div>
          <div className="col-md-6">
            <SkeletonElement type="skeleton-rect" style={{ height: "300px", borderRadius: "8px" }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export const CampusSkeleton = () => {
  return (
    <div className="w-100">
      <SkeletonElement type="skeleton-banner" style={{ height: "400px" }} />
      <div className="container py-5">
        <div className="d-flex gap-2 justify-content-center mb-4">
          <SkeletonElement type="skeleton-text" style={{ width: "100px", height: "38px" }} />
          <SkeletonElement type="skeleton-text" style={{ width: "100px", height: "38px" }} />
          <SkeletonElement type="skeleton-text" style={{ width: "100px", height: "38px" }} />
        </div>
        <div className="row g-4 mt-2">
          <div className="col-md-6">
            <SkeletonElement type="skeleton-rect" style={{ height: "300px", borderRadius: "8px" }} />
          </div>
          <div className="col-md-6">
            <SkeletonElement type="skeleton-title" />
            <SkeletonElement type="skeleton-text" />
            <SkeletonElement type="skeleton-text" />
            <SkeletonElement type="skeleton-text" className="medium" />
          </div>
        </div>
      </div>
    </div>
  );
};
